/**
 * Keeps the native Shopify contact form as the single submission owner while
 * making its long request easier to complete in small, related groups.
 */
(() => {
  const selector = '[data-request-form]';

  document.querySelectorAll(selector).forEach((form) => {
    const panels = Array.from(form.querySelectorAll('[data-request-step]'));
    const progressCount = form.querySelector('[data-request-progress-count]');
    const status = form.querySelector('[data-request-status]');
    const replyMethod = form.querySelector('[name="contact[best way to reach you]"]');
    const phoneField = form.querySelector('[data-request-phone-field]');
    const phone = form.querySelector('[data-request-phone]');
    let activeIndex = 0;

    if (panels.length < 2) return;

    const showStep = (nextIndex, focusHeading = false) => {
      activeIndex = Math.max(0, Math.min(nextIndex, panels.length - 1));

      panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      const stageTitle = panels[activeIndex].querySelector('.request-form__step-title')?.textContent.trim();
      if (progressCount) {
        progressCount.textContent = `Step ${activeIndex + 1} of ${panels.length}${stageTitle ? ` · ${stageTitle}` : ''}`;
      }
      if (status) status.textContent = '';

      if (focusHeading) {
        const heading = panels[activeIndex].querySelector('.request-form__step-title');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus();
        }
      }
    };

    const validateStep = () => {
      const fields = panels[activeIndex].querySelectorAll('input, select, textarea');
      const invalidField = Array.from(fields).find((field) => !field.checkValidity());

      if (!invalidField) return true;
      invalidField.reportValidity();
      if (status) status.textContent = 'Please complete the required fields before continuing.';
      return false;
    };

    form.classList.add('is-enhanced');

    const syncPhoneRequirement = () => {
      if (!replyMethod || !phoneField || !phone) return;
      const requiresPhone = replyMethod.selectedOptions[0]?.hasAttribute('data-requires-phone') ?? false;
      phoneField.hidden = !requiresPhone;
      phone.required = requiresPhone;
      if (!requiresPhone) phone.value = '';
    };

    if (replyMethod) replyMethod.addEventListener('change', syncPhoneRequirement);
    syncPhoneRequirement();
    showStep(0);

    form.querySelectorAll('[data-request-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (validateStep()) showStep(activeIndex + 1, true);
      });
    });

    form.querySelectorAll('[data-request-back]').forEach((button) => {
      button.addEventListener('click', () => showStep(activeIndex - 1, true));
    });
  });
})();
